/* eslint-disable */
import LazySizes from 'lazysizes';
import Unveilhooks from 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
/* eslint-enable */

import { onDocumentReady } from '@cornell-engineering/js/utils';
import deployGuard from '@cornell-engineering/js/utils/deploy-guard';

// Components
import Menu from '@cornell-engineering/js/components/menu';
import FooterAnimation from '@cornell-engineering/js/components/footer-animation';
import Splide from '@splidejs/splide';

// Before onDocumentReady so the listener is in place before any import() runs
deployGuard();

onDocumentReady(() => {
  console.log('Hello from the Cornell Engineering theme scripts!'); // eslint-disable-line

  import(
    /* webpackChunkName: "offSiteLinks" */ '@cornell-engineering/js/components/offSiteLinks'
  ).then(module => {
    const offSiteLinks = module.default;
    new offSiteLinks();
  });

  if (process.env.NODE_ENV === 'development') {
    import(
      /* webpackChunkName: "toggle-grid" */ '@cornell-engineering/js/components/toggle-grid'
    ).then(module => {
      const ToggleGrid = module.default;
      new ToggleGrid();
    });
  }

  new FooterAnimation();

  const MENU_CLASS = '.js--menu';
  if (document.querySelector(MENU_CLASS)) {
    new Menu(MENU_CLASS);
  }

  if (document.querySelector('.js--primary-nav')) {
    import(
      /* webpackChunkName: "primary-nav" */ '@cornell-engineering/js/components/primary-nav'
    ).then(module => {
      const PrimaryNav = module.default;
      new PrimaryNav();
    });
  }

  if (document.querySelector('.wp-block-video video')) {
    const video = document.querySelector('.wp-block-video video');
    const autoplay = video.hasAttribute('autoplay');
    import(
      /* webpackChunkName: "video-pause" */ '@cornell-engineering/js/components/video-pause'
    ).then(module => {
      const VideoPause = module.default;
      new VideoPause({ autoplay });
    });
  }

  if (document.querySelector('.js--anchor-nav')) {
    import(
      /* webpackChunkName: "anchor-nav" */ '@cornell-engineering/js/components/anchor-nav'
    ).then(module => {
      const AnchorNav = module.default;
      new AnchorNav();
    });
  }

  if (document.querySelector('.js--department-menu')) {
    import(
      /* webpackChunkName: "department-menu" */ '@cornell-engineering/js/components/department-menu'
    ).then(module => {
      const DepartmentMenu = module.default;
      new DepartmentMenu();
    });
  }

  if (document.querySelector('.js-hang-punc')) {
    import(
      /* webpackChunkName: "hang-punctuation" */ '@cornell-engineering/js/components/hang-punctuation'
    ).then(module => {
      const HangPunctuation = module.default;
      new HangPunctuation();
    });
  }

  const tabsWrapper = document.querySelector('.js-tabs');
  if (tabsWrapper) {
    import(/* webpackChunkName: "tabs" */ '@cornell-engineering/js/components/tabs').then(
      module => {
        const Tabs = module.default;
        new Tabs(tabsWrapper);
      },
    );
  }

  const peopleSearchRoot = document.querySelector('.js-people-search');
  if (peopleSearchRoot) {
    import(
      /* webpackChunkName: "people-search" */ '@cornell-engineering/js/components/algolia/people-search'
    ).then(module => {
      const PeopleSearch = module.default;
      const peopleSearch = new PeopleSearch(peopleSearchRoot);
      peopleSearch.init();
    });
  }

  const eventSearchRoot = document.querySelector('.js-event-search');
  if (eventSearchRoot) {
    import(
      /* webpackChunkName: "event-search" */ '@cornell-engineering/js/components/algolia/event-search'
    ).then(module => {
      const EventSearch = module.default;
      const eventSearch = new EventSearch(eventSearchRoot);
      eventSearch.init();
    });
  }

  const newsSearchRoot = document.querySelector('.js-news-search');
  if (newsSearchRoot) {
    import(
      /* webpackChunkName: "news-search" */ '@cornell-engineering/js/components/algolia/news-search'
    ).then(module => {
      const NewsSearch = module.default;
      const newsSearch = new NewsSearch(newsSearchRoot);
      newsSearch.init();
    });
  }

  const globalSearchRoot = document.querySelector('.js-search');
  if (globalSearchRoot) {
    import(
      /* webpackChunkName: "search" */ '@cornell-engineering/js/components/algolia/global-search'
    ).then(module => {
      const GlobalSearch = module.default;
      const globalSearch = new GlobalSearch(globalSearchRoot);
      globalSearch.init();
    });
  }

  const programFinderRoot = document.querySelector('.js-program-finder');
  if (programFinderRoot) {
    import(
      /* webpackChunkName: "search" */ '@cornell-engineering/js/components/algolia/program-finder'
    ).then(module => {
      const ProgramFinder = module.default;
      new ProgramFinder(programFinderRoot);
    });
  }

  const splides = Array.from(document.querySelectorAll('.splide'));
  splides.map(el => {
    const splide = new Splide(el).mount();

    const screenReaderLive = document.createElement('div');
    screenReaderLive.setAttribute('aria-live', 'polite');
    screenReaderLive.setAttribute('aria-atomic', 'true');
    screenReaderLive.setAttribute('class', 'screen-reader-text');
    el.appendChild(screenReaderLive);

    splide.on('move', () => {
      screenReaderLive.textContent = `Slide ${splide.index + 1} of ${splide.length}`;
    });
  });

  const micrositeNav = document.querySelector('.microsite-nav__wrap');
  if (micrositeNav) {
    import(
      /* webpackChunkName: "microsite-nav" */ '@cornell-engineering/js/components/micrositeNav'
    ).then(module => {
      const MicrositeNav = module.default;
      MicrositeNav();
    });
  }

  // This is an example of how to do code splitting. The JS in this
  // referenced file will only be loaded on that page. Good for
  // when you have a large amount of JS only needed in one place
  //
  //  if (document.querySelector('#js-process')) {
  //    import(/* webpackChunkName: "process" */ './pages/process')
  //      .then(module => {
  //        const Process = module.default;
  //        this.process = new Process();
  //      });
  //  }
});
